import { Directive, ElementRef, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MatChipInput, MatChipList, MatChipsDefaultOptions, MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';

@Directive({
    selector: 'input[afiChipInputFor]',
    host: {
        'class': 'mat-chip-input mat-input-element',
        '(keydown)': '_keydown($event)',
        '(blur)': '_blur()',
        '(focus)': '_focus()',
        '(input)': '_onInput()',
    },
})
export class AfidiumChipInputDirective extends MatChipInput {
    @Input()
    public set afiChipInputFor(list: MatChipList){
        this.chipList = list;
    }

    @Output()
    public onDelete: EventEmitter<null> = new EventEmitter();

    constructor(_elementRef: ElementRef<HTMLInputElement>, @Inject(MAT_CHIPS_DEFAULT_OPTIONS) _defaultOptions: MatChipsDefaultOptions) {
        super(_elementRef, _defaultOptions);
    }

    public _keydown(event?: KeyboardEvent){
        // Material's ChipInput calls preventDefault on events
        // preventing forms submission even in the cases we want it
        if (event && this._inputElement && event.code === 'Enter' && !this._inputElement.value){
            return;
        }

        if (event && event.code === "Backspace" && !this._inputElement.value){
            this.onDelete.emit();
            return;
        }

        super._keydown(event);
    }
}